import {
  Component
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReactiveFormsModule
} from '@angular/forms';

import {
  MatInputModule
} from '@angular/material/input';

import {
  MatFormFieldModule
} from '@angular/material/form-field';

import { LineCellBaseComponent }
from '../line-cell-base/line-cell-base.component';

@Component({
  selector: 'app-line-cell-text',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule
  ],

  templateUrl:
    './line-cell-text.component.html'
})
export class LineCellTextComponent
extends LineCellBaseComponent {
}